import { render, staticRenderFns } from "./LearningSync.vue?vue&type=template&id=70092e61&scoped=true&"
import script from "./LearningSync.vue?vue&type=script&lang=js&"
export * from "./LearningSync.vue?vue&type=script&lang=js&"
import style0 from "./LearningSync.vue?vue&type=style&index=0&id=70092e61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70092e61",
  null
  
)

export default component.exports